import PayrollColor from './PayrollColor';
import EmailSettings from './EmailSettings';
import { ManageAttendanceFunctionality } from '../../Functionality/ManageAttendance';
import React from 'react';
import Receivers from './Receivers';
import AttendanceCycle from './AttendanceCycle';
import OvertimePolicyConfig from './OvertimePolicyConfig';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ManageAttendance = (
    {
        registerAction
    }
) => {

    const {
        emptyFields,
        user, setUser,
        item,
        handleChange,
        emailItem,
        handleChangeEmail,
        cycleItem,
        setCycleItem,
        handleChangeCycle,
        overtimeConfigItem,
        handleChangeOvertimeConfig,
        resetToDefaultPallet,
        disabled
    } = ManageAttendanceFunctionality({
        registerAction
    });

    return (
        <>
                <div className='row'>

                    <PayrollColor
                        item={item}
                        onChange={handleChange}
                        resetToDefaultPallet={resetToDefaultPallet}
                        disabled={disabled}
                    />

                    <AttendanceCycle
                        item={cycleItem}
                        setItem={setCycleItem}
                        onChange={handleChangeCycle}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />

                    <OvertimePolicyConfig
                        item={overtimeConfigItem}
                        onChange={handleChangeOvertimeConfig}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />

                    <EmailSettings
                        item={emailItem}
                        onChange={handleChangeEmail}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />

                    <Receivers
                        user={user}
                        setUser={setUser}
                        disabled={disabled}
                    />

                </div>
        </>
    );
};

export default ManageAttendance;
